export default "__VITE_ASSET__BtzX1KFY__"